import { NextPage } from 'next';
import { Fragment } from 'react';
// -------- custom component -------- //  
import NextLink from 'components/reuseable/links/NextLink';
import SEO from 'components/common/SEO'; 
import * as All from 'data/keywords'; 
import ProjectDetailsNavigation from 'components/common/ProjectDetailsNavigation';
import ContactFooterCombo from 'components/reuseable/ContactFooterCombo';

const details = {
  pageName: 'Box Boys',
  categories: 'seo, ppc, ecommerce design',
  description:
    'Box Boys is a local business that sells boxes and packaging materials. We were asked to design and develop a new website for them. SEOptimist Company also provided SEO and PPC services.',
  parentDirectories: 'seo-design-portfolio'
};

const Portfolio = All.LocalSEOArrays[4].keywords;
const contentRowClass = 'row gx-0';
const titleClass = 'display-6 mb-4';

const ProjectDetails: NextPage = () => {
  return (
    <Fragment>
      {/* <PageProgress /> */}
      {' '}
      <main className="content-wrapper">
        <SEO
          title={`${Portfolio[0].title} - ${details.pageName}`}
          description={details.description}
          tag={details.categories}
          urlPT={``}
urlENPT={``}
url={`${Portfolio[0].url}/${Portfolio[0].title.toLowerCase().replace(/ /g, '-')}`}
          image={`/img/clients/${Portfolio[0].title.toLowerCase().replace(/ /g, '-')}.jpg`}
          // updated=""
          // published=""
          // modified=""
        />
        {/* ========== heading section ========== */}
        <section className="overflow-hidden position-relative cardboard">
          <div className="color w-100"></div>
          <div className="container gx-0 text-center wrapper h-md-auto">
            <div className="hero-portfolio">
              <img
                className="w-auto mx-auto"
                style={{ transform: 'scale(0.8)' , maxWidth: '100% !important'}}
                src={`/img/clients/${Portfolio[1].title.toLowerCase().replace(/ /g, '-')}.png`}
                // srcSet={`/img/clients/${Portfolio[1].title.toLowerCase().replace(/ /g, '-')}-bg@2x.jpg 2x`}
                alt={`${Portfolio[1].title}`}
              />  
            </div>
            <div className="row mx-auto">
              <div className="col-md-12 mx-auto text-center">
                <div className="post-header mx-auto text-center">
                  {/* <div className="post-category text-line text-white">Identity</div> */}
                  &nbsp;
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* ========== details section ========== */}
        <section className="wrapper bg-light wrapper-border">
          <div className="container pt-14 pt-md-16 pb-13 pb-md-15 pe-md-10">
            <div className="row">
              <div className="col-lg-12 offset-lg-0">
                {/* <h1 className={titleClass}>{Portfolio[0].title}</h1> */}

                <div className={`overflow-hidden ${contentRowClass}`}>
                  <div className="col-md-9 text-justify order-0 pe-10">
                    {/* <h1 className="fs-15 text-uppercase text-white mb-3">- {Portfolio[0].title} -</h1>
                    <p className="display-4 text-capitalize">{details.pageName}</p> */}
                    <h1 className="display-6 mb-4">SEOptimist Case Study</h1>
                    <p className="display-6">
                      <strong className="caption">{details.pageName}</strong>
                    </p>
                    <p> 
                      <strong className="caption">{details.description}</strong>
                    </p>{' '}
                    <img
                      width={120}
                      height={120}
                      src={`/img/${All.localSEOPackages[1].title.toLowerCase().replace(/ /g, '-')}.jpg`}
                      alt={All.localSEOPackages[1].title}
                      style={{ background: 'transparent' }}
                      className="mb-5 me-3"
                    />
                    <img
                      width={'100%'}
                      height={'auto'}
                      src={`/img/clients/number-1-google.jpg`}
                      alt={`Number 1 Google`}
                      style={{ background: 'transparent', maxWidth: 666 }}
                      // className="mb"
                    />{' '}
                    <p>
                      <strong>
                        Page 1 for their desired keyword: <em>packing boxes Brighton</em>
                      </strong>
                    </p>
                    <h3 className="mt-10">{Portfolio[0].title}</h3>
                    <p>
                      Box Boys, a leading provider of packing boxes. At SEOptimist, we understand the
                      importance of delivering measurable results through effective digital marketing strategies. We're
                      proud to have helped Box Boys achieve significant success with their online presence, and we're
                      excited to share our success story with you.
                    </p>
                    <p>
                      When Box Boys approached us, they were looking for ways to increase their online visibility,
                      attract more traffic to their website, and ultimately, generate more revenue. They had a website
                      that was functional, but not optimized for search engines or user experience. Our team knew that
                      we needed to make significant improvements to their website and implement a robust digital
                      marketing strategy to help them achieve their goals.
                    </p> <img
                      width={'100%'}
                      height={'auto'}
                      src={`/img/clients/${Portfolio[2].title.toLowerCase().replace(/ /g, '-')}.jpg`}
                      alt={Portfolio[2].title}
                      style={{ background: 'transparent' }}
                      className="mb-10 rounded-3 mw"
                    />
                    <h3>{Portfolio[2].title}</h3>
                    <p>
                      Our first step was to design and develop a custom WordPress website that was optimized for search
                      engines and user experience. We worked closely with Box Boys to understand their unique needs and
                      goals, and we created a website that was visually appealing, easy to navigate, and
                      mobile-friendly. We also optimized the website's content and structure to ensure that it was
                      search engine-friendly, helping it to rank higher on search engine results pages (SERPs).
                    </p>
                    {/* <h3>{Portfolio[3].title}</h3> */}
                    <p>
                      Once the website was live, we implemented a comprehensive SEO strategy to help Box Boys increase
                      their online visibility and attract more traffic to their website. We conducted keyword research
                      and implemented on-page optimization techniques to ensure that their website was ranking for
                      relevant keywords. It's all part of our comitment to be the best SEO company in London. We also
                      created high-quality content that was optimized for search engines and user experience, driving
                      more traffic to the website and improving engagement.
                    </p>
                    <p>
                      Through our digital marketing efforts, we were able to help Box Boys achieve a 100% increase in
                      ROI. They saw a significant increase in website traffic and engagement, resulting in more leads
                      and sales. Our ongoing SEO efforts have also helped Box Boys maintain their online visibility and
                      continue to generate revenue.
                    </p>
                    <p>
                      At SEOptimist  <NextLink title={All.HomeList[0].title} href="/" />, we understand the unique challenges
                      that businesses face when it comes to digital marketing. That's why we offer customized solutions
                      to help businesses achieve their online goals. Contact us today to learn more about our digital
                      marketing services and how we can help your business achieve success online.
                    </p>{' '}
                   
                    <p></p>
                    <NextLink title="Contact" href="/#contact" className="more hover" />
                  </div>

                  <div className="col-md-3 ms-auto order-1 pt-10 text-start">
                    <img
                      width={200}
                      height={'auto'}
                      src={`/img/clients/${Portfolio[0].title.toLowerCase().replace(/ /g, '-')}.jpg`}
                      alt={Portfolio[0].title}
                      style={{ background: 'transparent' }}
                      className="mb-10 rounded-top rounded-3"
                    />
                    <ul className="list-unstyled">
                      <li>
                        <h5 className="mb-1">Categories</h5>
                        <p>{details.categories}</p>
                      </li>

                      <li>
                        <h5 className="mb-1">Client Name</h5>
                        <p>{details.pageName}</p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <LocalSEO initialslide={0} /> */}
        </section>

        <ProjectDetailsNavigation />
        </main>
      <ContactFooterCombo location="london" />
    </Fragment>
  );
};

export default ProjectDetails;
